(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const modal = document.querySelector('[id^="PopupModal-KnifeAgreement"]');
    if (
      !modal ||
      typeof modal.show !== "function" ||
      typeof modal.hide !== "function"
    )
      return;

    let initialized = false;

    function initModalContents() {
      if (initialized) return;

      const nameInput = modal.querySelector("#agreement-fullname");
      const checkbox = modal.querySelector("#agreement-checkbox");
      const acceptBtn = modal.querySelector(".agreement-popup__accept");
      const rejectBtn = modal.querySelector(".agreement-popup__reject");
      const errorElement = modal.querySelector("#agreement-error");
      if (!nameInput || !checkbox || !acceptBtn || !rejectBtn || !errorElement)
        return;

      function isValidName() {
        const val = (nameInput.value || "").trim();
        const words = val.split(/\s+/).filter(Boolean);
        return words.length >= 2;
      }

      function updateAcceptState() {
        const validName = isValidName();
        const isChecked = checkbox.checked;
        if (isChecked && !validName) {
          errorElement.textContent =
            "You must enter your full name before proceeding.";
          errorElement.style.display = "block";
        } else {
          errorElement.textContent = "";
          errorElement.style.display = "none";
        }
        acceptBtn.disabled = !(isChecked && validName);
      }

      checkbox.addEventListener("change", updateAcceptState);
      nameInput.addEventListener("input", updateAcceptState);

      rejectBtn.addEventListener("click", () => {
        modal.hide();
      });

      acceptBtn.addEventListener("click", () => {
        if (acceptBtn.disabled) return;
        const fullName = (nameInput.value || "").trim();
        const now = new Date();
        const month = ("0" + (now.getMonth() + 1)).slice(-2);
        const day = ("0" + now.getDate()).slice(-2);
        const year = String(now.getFullYear()).slice(-2);
        const formattedDate = `${month}/${day}/${year}`;
        document
          .querySelectorAll('product-form form[action*="/cart/add"]')
          .forEach((form) => {
            ["Signature", "Date"].forEach((prop) => {
              const existing = form.querySelector(
                `input[name="properties[${prop}]"]`
              );
              if (existing) existing.remove();
            });
            const sigInput = document.createElement("input");
            sigInput.type = "hidden";
            sigInput.name = "properties[Signature]";
            sigInput.value = fullName;
            form.appendChild(sigInput);
            const dateInput = document.createElement("input");
            dateInput.type = "hidden";
            dateInput.name = "properties[Date]";
            dateInput.value = formattedDate;
            form.appendChild(dateInput);
          });
        modal.classList.add("agreement-popup-accepted");
        modal.hide();
        const firstForm = document.querySelector("product-form");
        if (firstForm) {
          const originalButton = firstForm.querySelector(
            'button[type="submit"][name="add"]'
          );
          if (originalButton) {
            originalButton.click();
          }
        }
      });

      updateAcceptState();
      initialized = true;
    }

    // Handle modal-opener buttons (e.g., agreement link)
    const modalOpeners = document.querySelectorAll(
      'modal-opener[data-modal^="#PopupModal-KnifeAgreement"]'
    );
    modalOpeners.forEach((opener) => {
      const openerBtn = opener.querySelector("button");
      if (!openerBtn) return;
      openerBtn.addEventListener("click", function (event) {
        initModalContents();
      });
    });

    // Handle Add to Cart buttons
    const productForms = document.querySelectorAll("product-form");
    productForms.forEach((pf) => {
      const submitBtn = pf.querySelector('button[type="submit"][name="add"]');
      if (!submitBtn) return;
      submitBtn.addEventListener("click", function (event) {
        if (modal.classList.contains("agreement-popup-accepted")) return;
        event.preventDefault();
        modal.show(this);
        initModalContents();
      });
    });
  });
})();
